import React, { useState, useEffect, useContext } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
  Box,
  DialogContent,
  DialogContentText,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  obterVerbasManuais,
  obterIncidenciaVerbasManuais,
  atualizarIncidenciaVerbasManuais,
  criarVerbaManual,
  atualizarVerbaManual,
  deletarVerbaManual,
  obterVerbasManuaisPorTexto,
} from "../../services/api-esocial.service";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import CreateIcon from "@mui/icons-material/Create";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import { CurrencyExchange, EditNote, EventNote } from "@mui/icons-material";
import VerbasManualForm from "src/forms/VerbasManualForm";
import Draggable from "react-draggable";
import IncidenciasVerbaManualForm from "src/forms/IncidenciasVerbaManualForm";
import { simplifyString } from "../../utils/simplify_string";
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const VerbasManuais = () => {
  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [idVerbaManual, setIdVerbaManual] = useState(null);
  const [verbasData, setVerbasData] = useState([]);
  const [incidenciasData, setIncidenciasData] = useState([]);
  const [editRowData, setEditRowData] = useState({});
  const [editRowDataIncidencias, setEditRowDataIncidencias] = useState({});
  const [indexExclusao, setIndexExclusao] = useState()
  const [openModalIncidencias, setOpenModalIncidencias] = useState(false);
  const [openModalVerbas, setOpenModalVerbas] = useState(false);
  const [openModalExclusaoVerbas, setOpenModalExclusaoVerbas] = useState(false);
  const [openModalEditIncidencias, setOpenModalEditIncidencias] = useState(false);
  const [openModalExclusaoIncidencias, setOpenModalExclusaoIncidencias] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const handleAtualizarTabela = async () => {
    if (idGrupoEconomico !== null && idEmpresa !== null) {
      setLoading(true);
      await getVerbas(idEmpresa);
      setLoading(false);
    } else {
      setLoading(true);
      setVerbasData([]);
      setLoading(false);
    }
  }
  useEffect(() => {
    handleAtualizarTabela();
  }, [idEmpresa]);

  const ViewIncidenciasModal = () => {
    const styleHead = { color: 'white', fontWeight: 'bold', padding: '0' }
    const styleRow = { padding: '4px' }
    const novaLista = incidenciasData.map((item, index) => {
      return (
        <TableRow key={index}>
          <TableCell sx={styleRow} align="center">{item.inivalid}</TableCell>
          <TableCell sx={styleRow} align="center">{handleTipoIncidencia(item.id_esocial_tipo_incidencia_verba)}</TableCell>
          <TableCell sx={styleRow} align="center">
            <CreateIcon
              className={styles.botaoPopupEditar}
              onClick={() => handleOpenEditIncidenciasModal(item, index)}
            />
            <DeleteIcon
              className={styles.botaoPopupExcluir}
              onClick={() => {
                setIndexExclusao(index);
                handleOpenExclusaoIncidenciasModal();
              }}
            />
          </TableCell>
        </TableRow>
      )
    })
    return (
      <>
        {incidenciasData.length !== 0 ?
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ background: '#0f2047' }}>
                <TableRow>
                  <TableCell sx={styleHead} align="center">Inicio da Validade</TableCell>
                  <TableCell sx={styleHead} align="center">Tipo de Incidência</TableCell>
                  <TableCell sx={styleHead} align="center">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {novaLista}
              </TableBody>
            </Table>
          </TableContainer>
          : <h3>Não possuem Incidências para esta Verba.</h3>}
      </>
    )
  }

  const handleTipoIncidencia = (item) => {
    let tipoIncidencia = ''
    switch (item) {
      case 1:
        tipoIncidencia = 'Sim'
        break;
      case 2:
        tipoIncidencia = 'Não'
        break;
      case 3:
        tipoIncidencia = 'Nunca'
        break;

      default:
        break;
    }

    return tipoIncidencia
  }

  const handleOpenIncidenciasModal = async (row) => {
    setIdVerbaManual(row.idEsocialVerbaManual)
    const response = await obterIncidenciaVerbasManuais(idEmpresa, row.idEsocialVerbaManual)
    const incidencias = response.incidenciasVerbaManual

    const novaLista = incidencias.map(item => {
      const splitInicio = item.inivalid.split("-")
      const novoInicio = `${splitInicio[1]}/${splitInicio[0]}`
      return {
        ...item,
        id_esocial_tipo_incidencia_verba: item.id_esocial_tipo_incidencia_verba,
        inivalid: novoInicio,
      }
    })

    setIncidenciasData(novaLista)
    setOpenModalIncidencias(true)
  }

  const handleCloseIncidenciasModal = () => {
    setOpenModalIncidencias(false)
  }

  const handleOpenModalVerbas = (rowData) => {
    setEditRowData(rowData)
    setOpenModalVerbas(true)
  }

  const handleCloseModalVerbas = () => {
    setOpenModalVerbas(false)
  }

  const handleClickExclusaoVerbas = (rowData) => {
    setEditRowData(rowData);
    setOpenModalExclusaoVerbas(true)
  }

  const handleCloseModalExclusaoVerbas = () => {
    setOpenModalExclusaoVerbas(false)
  }

  const handleTratarData = (data) => {
    const splitDate = data.split("/")
    const date = new Date(`${splitDate[0]}/01/${splitDate[1]}`)
    return date
  }

  const handleOpenEditIncidenciasModal = (rowData, index) => {
    if (rowData) {
      const date = handleTratarData(rowData.inivalid)
      const newRowData = {
        ...rowData,
        inivalid: date,
        index: index
      }
      setEditRowDataIncidencias(newRowData)
    } else {
      setEditRowDataIncidencias({})
    }

    setOpenModalEditIncidencias(true)
  }

  const handleCloseEditIncidenciasModal = () => {
    setOpenModalEditIncidencias(false)
  }

  const handleOpenExclusaoIncidenciasModal = () => {
    setOpenModalExclusaoIncidencias(true)
  }

  const handleExclusaoIncidenciasModal = () => {
    const listaIncidencias = [...incidenciasData]
    listaIncidencias.splice(indexExclusao, 1)
    setIncidenciasData(listaIncidencias)
    handleCloseExclusaoIncidenciasModal()
  }

  const handleCloseExclusaoIncidenciasModal = () => {
    setOpenModalExclusaoIncidencias(false)
  }

  const handleSaveChangesVerba = async (data) => {
    const novoDado = { verbaManual: { ...data.verbaManual, tipoRubrica: data.verbaManual.tipoRubrica[0] } }
    if (!editRowData.idEsocialVerbaManual) {
      // Cadastra
      await criarVerbaManual(idEmpresa, novoDado)
        .then(async (response) => {
          setMsg(response.mensagem);
          setOpenSnackbarSucesso(true)
          // Buscar dados novamente para renderizar
          handleAtualizarTabela();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      //Atualiza
      await atualizarVerbaManual(idEmpresa, editRowData.idEsocialVerbaManual, novoDado)
        .then(async (response) => {
          setMsg(response.mensagem);
          setOpenSnackbarSucesso(true)
          // Buscar dados novamente para renderizar
          handleAtualizarTabela();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }

    handleCloseModalVerbas();
  }

  const handleDeleteVerbas = async () => {
    await deletarVerbaManual(idEmpresa, editRowData.idEsocialVerbaManual)
      .then(async (response) => {
        setMsg(response.mensagem);
        setOpenSnackbarSucesso(true)
        // Buscar dados novamente para renderizar
        handleAtualizarTabela();
        handleCloseModalExclusaoVerbas();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  }

  const handleSaveChangesIncidencias = async () => {
    const tratarDados = incidenciasData.length !== 0 ? incidenciasData.map(item => {
      const splitData = item.inivalid.split("/")
      const novaData = `${splitData[1]}-${splitData[0]}`
      return {
        idEsocialTipoIncidenciaVerba: item.id_esocial_tipo_incidencia_verba,
        inivalid: novaData
      }
    }) : incidenciasData
    const dadosParaAPI = { incidenciasVerbaManual: tratarDados }
    await atualizarIncidenciaVerbasManuais(idEmpresa, idVerbaManual, dadosParaAPI)
      .then(() => {
        setMsg('Incidências salvas com sucesso!')
        setOpenSnackbarSucesso(true)
        handleCloseIncidenciasModal()
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  }

  const handleEditIncidencias = (data) => {
    const incidencia = data.incidenciasVerbaManual
    const listaIncidencias = [...incidenciasData]
    const tipoIncidencia = incidencia.id_esocial_tipo_incidencia_verba;

    const anoInicioIncidencia = incidencia.inivalid.getFullYear();
    let mesInicioincidencia = incidencia.inivalid.getMonth() + 1;
    if (mesInicioincidencia < 10) mesInicioincidencia = '0' + mesInicioincidencia; 

    const inicioIncidencia = `${mesInicioincidencia}/${anoInicioIncidencia}`;

    const novosDados = {
      id_esocial_tipo_incidencia_verba: tipoIncidencia ? tipoIncidencia : incidencia.id_esocial_tipo_incidencia_verba,
      inivalid: inicioIncidencia
    }

    for(const incidencia of listaIncidencias) {
      if ( novosDados.inivalid === incidencia.inivalid ) {
        setMsg('Inicio de validade já listado!');
        setOpenSnackbarErro(true);
        return;
      }
    }

    if (!isNaN(editRowDataIncidencias.index) && editRowDataIncidencias.index >= 0) {
      listaIncidencias.splice(editRowDataIncidencias.index, 1, novosDados);

      setIncidenciasData(listaIncidencias.sort((a,b)=>{
        const [monthA, yearA] = a.inivalid.split('/').map(Number);
        const [monthB, yearB] = b.inivalid.split('/').map(Number);
        return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1);
      }));
    } else {
      setIncidenciasData([ ...incidenciasData, novosDados ].sort((a,b)=>{
        const [monthA, yearA] = a.inivalid.split('/').map(Number);
        const [monthB, yearB] = b.inivalid.split('/').map(Number);
        return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1);
      }));
    }

    handleCloseEditIncidenciasModal()
  }

  const columns = [
    { id: "idEsocialVerbaManual", label: "ID", field: "idEsocialVerbaManual" },
    { id: "idTabelaRubrica", label: "ID da Tabela\nde Rubricas", field: "idTabelaRubrica" },
    { id: "codRubrica", label: "Código da\nRubrica", field: "codRubrica_cellVal" },
    { id: "tipoRubrica", label: "Tipo de\nRubrica", field: "tipoRubrica" },
    { id: "descricaoRubrica", label: "Descrição\nda Rubrica", field: "descricaoRubrica" },
    { id: "codigoIncidencia", label: "Código de Incidência", field: "codigoIncidencia" },
    { label: "Incide", render: (id) => verificaIncidencia(id)},
    {
      label: "Incidências", no_ordering: true, render: (id) =>
        <>
          <IconButton
            aria-label="edit"
            className={styles.iconeTabela}
            onClick={() => handleOpenIncidenciasModal(id)}
          >
            <EventNote />
          </IconButton>
        </>
    },
  ];

  const verificaIncidencia = (value) => {
    const codInc = value.codigoIncidencia;
    if(!codInc) return '';
    return (codInc.startsWith('0'))
      ? "Sim"
      : "Não";
  }

  const getVerbas = async (idEmpresa) => {
    try {
      const response = await obterVerbasManuais(idEmpresa);
      const verbas = response.verbasManuais;
      const novaLista = verbas.map(item => {

        let tipo_rubrica = ''
        switch (item.tipoRubrica) {
          case 'P':
            tipo_rubrica = 'Provento'
            break;
          case 'D':
            tipo_rubrica = 'Desconto'
            break;
          default:
            break;
        }

        return {
          ...item,
          tipoRubrica: tipo_rubrica,
          codRubrica_cellVal: simplifyString(item.codRubrica)
        }


      })
      setVerbasData(novaLista);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterVerbasManuaisPorTexto(idEmpresa, event.target.value);
      const verbas = response.verbasManuais;
      const novaLista = verbas.map(item => {

        let tipo_rubrica = ''
        switch (item.tipoRubrica) {
          case 'P':
            tipo_rubrica = 'Provento'
            break;
          case 'D':
            tipo_rubrica = 'Desconto'
            break;
          default:
            break;
        }

        return {
          ...item,
          tipoRubrica: tipo_rubrica,
          codRubrica_cellVal: simplifyString(item.codRubrica)
        }

      })
      setVerbasData(novaLista);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setVerbasData([]);
      }
      else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      };
    }
    setLoading(false);
  };

  const handleGrupoECnpjChange = async (ids) => {
    setIdGrupoEconomico(ids.GE);
    setIdEmpresa(ids.CNPJ);
  }

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <EditNote fontSize="30px" />
        }
        headerTitle={"Verbas Manuais"}
        handleDebounceChange={handleDebouncerChange}
        AutoCompleteGrupoECnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
        modalButtonLabel='Adicionar'
        handleOpenModal={handleOpenModalVerbas}
      />

      {/* COMPONENTES DE VERBAS */}

      <TabelaDinamica
        data={verbasData}
        columns={columns}
        loading={loading}
        onEditButtonClick={handleOpenModalVerbas}
        onDeleteButtonClick={handleClickExclusaoVerbas}
      />

      <Dialog
        open={openModalVerbas}
        onClose={handleCloseModalVerbas}
        PaperProps={{
          style: {
            width: "100%", // Defina a largura desejada
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <CurrencyExchange className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idEsocialVerbaManual
                ? "Edição de Verba Manual"
                : "Cadastro de Verba Manual"}
            </h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <VerbasManualForm
            verbaManualValues={Object.assign({}, editRowData)}
            onClose={handleCloseModalVerbas}
            onSubmit={handleSaveChangesVerba}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openModalExclusaoVerbas}
        onClose={handleCloseModalExclusaoVerbas}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente a verba {editRowData.idTabelaRubrica} - {editRowData.codRubrica}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseModalExclusaoVerbas}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoConfirmarExcluir} onClick={handleDeleteVerbas}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      {/* COMPONENTES DE INCIDÊNCIAS */}

      {/* MODAL DE CONSULTA */}

      <Dialog
        open={openModalIncidencias}
        onClose={handleCloseIncidenciasModal}
        PaperProps={{
          style: {
            width: "100%", // Defina a largura desejada
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupFlex}>
            <div className={styles.tituloPopupContainer}>
              <EventNote className={styles.iconeTituloPopup} />
              <h1 className={styles.tituloPopup}>
                Incidências
              </h1>
            </div>
            <Button
              className={styles.botaoNovo}
              onClick={() => handleOpenEditIncidenciasModal()}
              size="small"
            >
              Adicionar
            </Button>
          </div>
        </DialogTitle>
        <DialogContent sx={{ marginTop: '1rem' }}>
          <ViewIncidenciasModal />
        </DialogContent>
        <Box>
          <DialogActions className={styles.botoesPopupGeral}>
            <Button
              className={styles.botaoPopupCancelar}
              onClick={handleCloseIncidenciasModal}
              size="small"
            >
              Fechar
            </Button>
            <Button
              className={styles.botaoPopupSalvar}
              onClick={handleSaveChangesIncidencias}
              size="small"
            >
              Salvar
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      {/* MODAL DE CADASTRO/EDIÇÃO */}

      <Dialog
        open={openModalEditIncidencias}
        onClose={handleCloseEditIncidenciasModal}
        PaperProps={{
          style: {
            width: "100%", // Defina a largura desejada
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <EventNote className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              Incidência
            </h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <IncidenciasVerbaManualForm
            incidenciasVerbaManualValues={Object.assign({}, editRowDataIncidencias)}
            onClose={handleCloseEditIncidenciasModal}
            onSubmit={handleEditIncidencias}
          />
        </DialogContent>
      </Dialog>


      <Dialog
        open={openModalExclusaoIncidencias}
        onClose={handleCloseExclusaoIncidenciasModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente a incidência de {incidenciasData[indexExclusao]?.inivalid}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseExclusaoIncidenciasModal}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoConfirmarExcluir} onClick={handleExclusaoIncidenciasModal}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default VerbasManuais;
